import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { PrepareRelayContextProvider } from '../PrepareRelayContextProvider/PrepareRelayContextProvider.tsx';

import Header from '../Header/Header.jsx';

function HeaderRenderer(props) {
    const { environment, initialVariables, query, relayVariables } = props;

    const variables = {
        ...initialVariables,
        ...relayVariables,
    };

    return (
        <PrepareRelayContextProvider
            environment={environment}
            query={query}
            variables={variables}
            render={({ props: rendererProps }) => <Header {...rendererProps} {...variables} />}
        />
    );
}

HeaderRenderer.propTypes = {
    environment: PropTypes.object,
    initialVariables: PropTypes.object,
    query: PropTypes.object,
    relayVariables: PropTypes.object,
};

const mapStateToProps = ({ header }) => {
    return {
        relayVariables: header.relayVariables || {},
    };
};

export default connect(mapStateToProps)(HeaderRenderer);
